module.exports = {
  Facebook: 'https://www.facebook.com/BitcoinMartCA',
  Twitter: 'https://twitter.com/BitcoinMartATM',
  // Instagram: 'https://www.instagram.com/',
  // LinkedIn: 'https://www.linkedin.com',
};
